(function (global) {
  'use strict';

  const rows = (value) => Array.isArray(value) ? value : [];

  const buildEditorLines = ({ quoteLines, products, createId } = {}) => {
    const productsById = new Map(rows(products).map((product) => [String(product.id || ''), product]));
    return rows(quoteLines).map((line) => {
      const product = productsById.get(String(line.productId || '')) || {};
      const title = String(line.description || line.productName || product.name || product.description || '').trim() || 'Uten beskrivelse';
      const note = String(line.note || '').trim() || (product.description && product.description !== title ? product.description : '');
      return {
        id: line.id || createId('line'),
        desc: title,
        note,
        productId: line.productId || product.id || undefined,
        productName: line.productName || product.name || title,
        productNumber: line.productNumber || line.itemNumber || product.itemNumber || undefined,
        itemNumber: line.itemNumber || line.productNumber || product.itemNumber || undefined,
        qty: line.quantity,
        price: line.unitPrice,
        disc: line.discountValue || 0,
        discMode: line.discountType === 'amount' ? 'kr' : '%',
        vat: line.vatTreatment && line.vatTreatment !== 'standard' ? line.vatTreatment : line.vatRate,
        salesVatCode: line.salesVatCode || product.salesVatCode || undefined,
        salesAccountCode: line.salesAccountCode || product.salesAccountCode || undefined,
        type: line.type || (product.kind === 'physical' ? 'Vare' : product.kind === 'subscription' ? 'Abonnement' : product.kind === 'rental' ? 'Utleie' : undefined),
      };
    });
  };

  global.PlummeCustomerConversationOffers = { buildEditorLines };
})(typeof window !== 'undefined' ? window : globalThis);
